require('./transfersPaymentsAbroadInfo.scss');

//@vendor
const React = require('react');
//@utilities
const { FormattedText } = require('core/i18n').i18n;
//@components
const { OKSectionBox } = require('commonsComponents/OKSectionBox');

const TransfersPaymentsAbroadInfo = () => {
    return (
        <OKSectionBox className="transfers-payments-abroad-info">
            <h2 className="transfers-payments-abroad-info__title">
                <FormattedText value="transfersLanding-paymentsAbroad"/>
            </h2>
            <p className="transfers-payments-abroad-info__text">
                <FormattedText value="transfersLanding-paymentsAbroadText1"/>
            </p>
        </OKSectionBox>
    );
};

module.exports = TransfersPaymentsAbroadInfo;
